"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _reactDom = _interopRequireDefault(require("react-dom"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var body = document.getElementsByTagName('body')[0];
var Tooltip = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);
  var _super = _createSuper(Tooltip);
  function Tooltip() {
    var _this;
    _classCallCheck(this, Tooltip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      show: false
    });
    _defineProperty(_assertThisInitialized(_this), "tooltip", void 0);
    _defineProperty(_assertThisInitialized(_this), "trigger", void 0);
    _defineProperty(_assertThisInitialized(_this), "setTooltip", function () {
      if (!_this.tooltip || !_this.trigger) return;
      var triggerPos = _this.trigger.getBoundingClientRect();
      var tooltipPos = _this.tooltip.getBoundingClientRect();
      _this.tooltip.style.left = triggerPos.left + triggerPos.width / 2 - tooltipPos.width / 2 + 'px';
      var tooltipArrowHeight = 8;
      // default: tooltip appears from above
      // rotate: tooltip appears from below
      var topOffset = _this.props.rotate ? triggerPos.bottom + tooltipArrowHeight : triggerPos.top - tooltipPos.height - tooltipArrowHeight;
      _this.tooltip.style.top = "".concat(topOffset, "px");
    });
    _defineProperty(_assertThisInitialized(_this), "onHide", function () {
      _this.setState({
        show: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onShow", function () {
      _this.setState({
        show: true
      });
    });
    return _this;
  }
  _createClass(Tooltip, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.tooltip) return;
      this.setTooltip();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        text = _this$props.text,
        children = _this$props.children;
      if (!this.props.text) return children;

      // we expect a class name to be passed if customWidth prop exists as this class will define the custom width
      if (this.props.customWidth && !className) return children;

      /*
      - display tooltip container is set to true at all times
      - defaultTooltipArrow = if no `rotate` prop is passed then we just display the default tooltip arrow (facing down)
      - rotatedtooltipArrow = when `rotate` prop is passed we show the rotated tooltip arrow (facing up)
      - defaultSize = if no `customSize` prop is passed then we set the size of the tooltip box to be the default width of 150px
      - if the `customSize` prop is passed then we expect a class to be passed into also that defines the custom size
      */

      var containerClasses = (0, _classnames2.default)(_defineProperty({
        'tooltipContainer': true,
        'tooltipRotated': this.props.rotate,
        'defaultWidth': !this.props.customWidth
      }, className, !!className));
      var tooltipBody = /*#__PURE__*/_react.default.createElement("div", {
        className: containerClasses,
        ref: function ref(r) {
          return _this2.tooltip = r;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        role: "tooltip",
        className: "tooltip"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tooltip-inner"
      }, text)));
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.cloneElement(children, {
        onMouseEnter: this.onShow,
        onMouseLeave: this.onHide,
        onFocus: this.onShow,
        onBlur: this.onHide,
        ref: function ref(r) {
          return _this2.trigger = r;
        }
      }), this.props.openOnFocus ? /*#__PURE__*/_react.default.createElement("div", {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
        onFocus: this.onShow,
        onBlur: this.onHide
      }, text && /*#__PURE__*/_react.default.createElement("div", {
        className: "tooltipScreenReaderOnly"
      }, "Tooltip content: ", text), this.state.show && text && /*#__PURE__*/_reactDom.default.createPortal(tooltipBody, body)) : this.state.show && text && /*#__PURE__*/_reactDom.default.createPortal(tooltipBody, body));
    }
  }]);
  return Tooltip;
}(_react.PureComponent);
var _default = Tooltip;
exports.default = _default;